import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('FINES', {
  FETCH_FINES_REQUEST: null,
  FETCH_FINES_SUCCESS: null,
  FETCH_FINES_FAILURE: null,
  FETCH_FINES_PAYMENT_FORM_REQUEST: null,
  FETCH_FINES_PAYMENT_FORM_FAILURE: null,
  FETCH_FINES_PAYMENT_FORM_SUCCESS: null,
  EMPTY_FINES_PAYMENT: null,
  UPDATE_PAGE_REQUEST: null,
  UPDATE_PAGE_SUCCESS: null,
  UPDATE_PAGE_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/FinesConstants.js